import {
  getProjectThemeWithContrasts,
  SellerTheme as SellerProcessedTheme,
} from '@abbiamo/seller-theme-utils';
import { useMemo } from 'react';
import { SellerTheme } from '@seller-hermes/features/seller';
import { useStoreState } from '../easy-peasy';
import { useThemeToggler } from '../useThemeToggler';

export interface HermesTheme extends SellerProcessedTheme {
  logo_link: string;
  favicon: string;
  logo_bg: string;
  carrier_name: string;
}

export const defaultTheme: SellerTheme = {
  primary: '#6ED796',
  logo: '/logos/hermes.svg',
  logo_bg: '#6ED796',
  logo_link: 'https://www.abbiamolog.com',
  carrier_name: 'Abbiamo',
  favicon:
    'https://abbiamo-public.s3.amazonaws.com/seller-favicons/favicon.ico',
};

const useSellerTheme = (themeType?: 'light' | 'dark'): HermesTheme => {
  const rawTheme = useStoreState(
    (s) => s.login.sellerGroupUser.theme || defaultTheme
  );
  const { themeType: globalThemeType } = useThemeToggler();
  const theme = useMemo(() => {
    return getProjectThemeWithContrasts(
      rawTheme as any,
      themeType || globalThemeType
    ) as HermesTheme;
  }, [rawTheme, globalThemeType, themeType]);
  return theme;
};

export default useSellerTheme;
